import {
  matchWinnersLuckyLoad,
  matchWinnersRandomLoad
} from '../../../api/app/match'

// 幸运名次奖
async function loadLuckyWinners({ state }, query) {
  console.log(query)
  const R = await matchWinnersLuckyLoad(query)
  state.luckyWinners = R.list
  state._myLuckyInfo = R.myInfo || {
    rewardFlag: 0,
    rank: 0
  }
  console.log(state.luckyWinners)
  return R
}

// 随机奖励
async function loadRandomWinners({ state }, query) {
  const R = await matchWinnersRandomLoad(query)
  state.randomWinners = R.list
  state._myRandomInfo = R.myInfo || {
    rewardFlag: 0,
    rank: 0
  }
  return R
}

export default {
  loadLuckyWinners,
  loadRandomWinners
}
